import React from 'react';
import styles from "./welcomeheader.module.scss";
import logo from "../../styles/images/logo.svg";

export const WelcomeHeader = () => {
 
  return (<>
    <div className={styles.joinHeadersec}>
      <div className={styles.logoSec}>
        <img src={logo} alt="" />
      </div>
    </div>
  </>);
};